import { ArrowRight, Clock3, Mail, MapPinned, Phone, ShieldCheck } from 'lucide-react';
import { PHONE_DISPLAY, PHONE_HREF, servicePages } from '../../lib/schiek-content';

export default function Footer() {
  return (
    <footer className="border-t border-[#2f2720] bg-[#120f0d] py-14 text-[#f5eadb]">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-8 flex flex-col items-center justify-between gap-3 rounded-[1.1rem] border border-amber-300/15 bg-[#1a1512] px-5 py-4 text-center md:flex-row md:text-left">
          <div>
            <p className="text-sm font-semibold text-amber-300">Direkter Kontakt</p>
            <p className="mt-1 text-sm text-[#d9c9b8]">24/7 erreichbar in Berlin und Umgebung, ohne Vermittlungsplattform.</p>
          </div>
          <a
            href={PHONE_HREF}
            className="inline-flex items-center justify-center gap-2 rounded-full border border-amber-300/40 bg-[#f2bf63] px-5 py-2.5 text-sm font-semibold text-[#1c140d] transition-colors hover:bg-[#ffcf82]"
          >
            <Phone className="h-4 w-4" aria-hidden="true" />
            {PHONE_DISPLAY}
          </a>
        </div>

        <div className="grid grid-cols-1 gap-10 text-center md:grid-cols-4 md:text-left">
          <div className="md:col-span-2 flex flex-col items-center md:items-start">
            <a href="/" aria-label="Startseite Abschleppdienst Schiek" className="mb-4 flex flex-col items-center md:items-start gap-1">
              <span className="text-xl font-semibold tracking-[0.18em]">
                SCHIEK
              </span>
              <span className="text-sm text-[#d8c7b3]">
                Abschlepp- und Bergungsdienst Berlin
              </span>
            </a>
            <p className="mb-6 max-w-md text-sm text-[#d9c9b8] md:text-base">
              Abschleppdienst Schiek ist auf Pannendienst, Unfallbergung, Falschparker und Einsätze in Hof, Tiefgarage und auf Privatgrund ausgerichtet. Direkt in Berlin, mit sauberer Einsatzlogik.
            </p>
            <div className="flex justify-center space-x-4 md:justify-start">
              <a 
                href="tel:+4917655677271"
                aria-label="Telefon anrufen"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-[#2f2720] bg-[#1a1512] transition-colors hover:border-amber-300/60 hover:text-amber-300"
              >
                <Phone className="h-4 w-4" aria-hidden="true" />
              </a>
              <a 
                href="mailto:info@abschleppdienst-schiek.de"
                aria-label="E-Mail schreiben"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-[#2f2720] bg-[#1a1512] transition-colors hover:border-amber-300/60 hover:text-amber-300"
              >
                <Mail className="h-4 w-4" aria-hidden="true" />
              </a>
            </div>
          </div>

          <div className="flex flex-col items-center md:items-start">
            <h4 className="mb-4 text-lg font-semibold">
              Leistungen
            </h4>
            <ul className="space-y-2 text-sm text-[#d9c9b8] md:text-base">
              {servicePages.slice(0, 5).map((service) => (
                <li key={service.slug}>
                  <a href={`/leistungen/${service.slug}`} className="inline-flex items-center gap-2 transition-colors hover:text-amber-300">
                    {service.shortTitle}
                    <ArrowRight className="h-3.5 w-3.5" aria-hidden="true" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col items-center md:items-start">
            <h4 className="mb-4 text-lg font-semibold">
              Navigation
            </h4>
            <ul className="space-y-2 text-sm text-[#d9c9b8] md:text-base">
              <li>
                <a href="/#hero" className="transition-colors hover:text-amber-300">Startseite</a>
              </li>
              <li>
                <a href="/leistungen" className="transition-colors hover:text-amber-300">Leistungen</a>
              </li>
              <li>
                <a href="/notruf" className="transition-colors hover:text-amber-300">Notruf</a>
              </li>
              <li>
                <a href="/einsatzgebiete" className="transition-colors hover:text-amber-300">Einsatzgebiete</a>
              </li>
              <li>
                <a href="/faq" className="transition-colors hover:text-amber-300">FAQ</a>
              </li>
              <li>
                <a href="/kontakt" className="transition-colors hover:text-amber-300">Kontakt</a>
              </li>
              <li>
                <a href="/about" className="transition-colors hover:text-amber-300">Über uns</a>
              </li>
            </ul>
          </div>

          <div className="flex flex-col items-center md:items-start">
            <h4 className="mb-4 text-lg font-semibold">
              Kontakt
            </h4>
            <ul className="space-y-2 text-sm text-[#d9c9b8] md:text-base">
              <li className="inline-flex items-center gap-2">
                <ShieldCheck className="h-4 w-4 text-amber-300" aria-hidden="true" />
                <span><a href={PHONE_HREF} className="hover:text-amber-300">{PHONE_DISPLAY}</a></span>
              </li>
              <li className="inline-flex items-center gap-2">
                <Mail className="h-4 w-4 text-amber-300" aria-hidden="true" />
                <a href="mailto:info@abschleppdienst-schiek.de" className="hover:text-amber-300">info@abschleppdienst-schiek.de</a>
              </li>
              <li className="inline-flex items-center gap-2">
                <MapPinned className="h-4 w-4 text-amber-300" aria-hidden="true" />
                <span>Berlin und Umgebung</span>
              </li>
              <li className="inline-flex items-center gap-2">
                <Clock3 className="h-4 w-4 text-amber-300" aria-hidden="true" />
                <span>24/7 Bereitschaft</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-[#2f2720] pt-6 md:flex-row">
          <p className="text-center text-xs text-[#9f8f7f] md:text-left md:text-sm">
            © 2026 Abschleppdienst Schiek. Alle Rechte vorbehalten.
          </p>
          <div className="flex justify-center space-x-6 md:justify-end">
            <a href="/impressum" className="text-xs transition-colors hover:text-amber-300 md:text-sm">
              Impressum
            </a>
            <a href="/datenschutz" className="text-xs transition-colors hover:text-amber-300 md:text-sm">
              Datenschutz
            </a>
            <a href="/cookie" className="text-xs transition-colors hover:text-amber-300 md:text-sm">
              Cookie-Einstellungen
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
